import React from 'react';
import {Suggestions} from 'components';

export function Strengths(props) {
  return (
    <Suggestions.List {...props}>
      <p>Sense of Humor</p>
      <p>Problem Solving</p>
      <p>Troubleshooting</p>
      <p>Courage</p>
      <p>Self Learning</p>
      <p>Building with my hands</p>
      <p>Analyzing</p>
      <p>Planning</p>
      <p>Training</p>
      <p>Teaching others</p>
      <p>Exercising</p>
      <p>Writing</p>
      <p>Memorizing</p>
      <p>Drawing</p>
      <p>Fixing</p>
      <p>Persuading</p>
      <p>Leadership</p>
      <p>Organization</p>
      <p>Determination</p>
      <p>Curiosity</p>
      <p>Focus</p>
      <p>Confidence</p>
      <p>Public Speaking</p>
      <p>Persistence</p>
      <p>Patience</p>
      <p>Self-control</p>
      <p>Creativity</p>
    </Suggestions.List>
  );
}
